import type {SwitchProps} from '@yandex-delivery/blocks'
import {Switch} from '@yandex-delivery/blocks'
import React from 'react'
import {useController, useFormContext} from 'react-hook-form'

type SwitchControlledType = Omit<SwitchProps, 'name' | 'on'> & {name: string}

export const SwitchControlled = ({name, ...props}: SwitchControlledType): React.ReactElement => {
  const {control} = useFormContext()
  const {
    field: {value, ...field},
  } = useController({control, defaultValue: false, name})

  return <Switch {...props} {...field} on={value} />
}
